module.exports = __webpack_public_path__ + "img/mailing.f99d2ee1.png";